import { calculatedParamsMiddleware, fetchTargets, mergeMiddlewares } from '@cian/adfox';
import * as React from 'react';
import { IAdfoxConstants } from '../adfox/constants';
import { Link } from '../link/link';

import * as styles from './promo_mortgage.css';

export interface IPromoMortgageProps {
  url: string;
  title: string;
  description: string;
  imageUrl: string;
  backgroundColor: string;
  textColor: string;
}

export const adFoxMortgageMiddleware = (constants: IAdfoxConstants) => {
  return mergeMiddlewares(
    calculatedParamsMiddleware(),
    fetchTargets('apps', {
      baseUrl: `//${window.__mainpage_api_host__ || window.location.host}/`,
    }),
    Promise.resolve(constants),
  );
};

export class PromoMortgage extends React.Component<IPromoMortgageProps, {}> {
  public render() {
    const { url, imageUrl, title, description, backgroundColor, textColor } = this.props;

    if (!url) {
      return <div />;
    } else {
      return (
        <Link href={url} target="_blank" rel="noopener noreferrer">
          <div
            className={styles['promo_mortgage-container']}
            style={{
              backgroundColor, // stylelint-disable-line
            }}
          >
            <div
              className={styles['promo_mortgage-image']}
              style={{
                backgroundImage: `url(${imageUrl})`,
              }}
            ></div>
            <div className={styles['promo_mortgage-text_container']}>
              <div
                className={styles['promo_mortgage-text_container-header']}
                style={{
                  color: textColor, // stylelint-disable-line
                }}
              >
                {title}
              </div>
              <div
                className={styles['promo_mortgage-text_container-footer']}
                style={{
                  color: textColor, // stylelint-disable-line
                }}
              >
                {description}
              </div>
            </div>
          </div>
        </Link>
      );
    }
  }
}
